module.exports = __webpack_public_path__ + "static/media/16-10.ef734fc8.mp3";